import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, Transition as _Transition, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/close.svg'
import _imports_1 from '@/assets/img/location.pin.svg'
import _imports_2 from '@/assets/img/down_arrow.svg'
import _imports_3 from '@/assets/img/location.alt.svg'
import _imports_4 from '@/assets/img/arrow.up.svg'


const _withScopeId = n => (_pushScopeId("data-v-15be4975"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "tecnicoDetailContainer",
  ref: "tecnicoDetailContainer"
}
const _hoisted_2 = { class: "closeButtonContainer pointer" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "divider" }, null, -1))
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { class: "d-flex align-items-center" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_1 }, null, -1))
const _hoisted_7 = { class: "ms-2" }
const _hoisted_8 = { class: "fs_12 fw_500" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "d-flex align-items-center my-3" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_2 })
], -1))
const _hoisted_10 = { class: "d-flex align-items-center" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_3 }, null, -1))
const _hoisted_12 = { class: "ms-2" }
const _hoisted_13 = { class: "fs_12 fw_500 d-block mt-1" }
const _hoisted_14 = { class: "fs_12 fw_500" }
const _hoisted_15 = {
  key: 0,
  class: "mapsRouteSentContainer mt-4"
}
const _hoisted_16 = { class: "d-flex align-items-center mt-2" }
const _hoisted_17 = ["href"]
const _hoisted_18 = { class: "textContainer" }
const _hoisted_19 = { key: 1 }
const _hoisted_20 = { class: "ticketsContainer mt-4" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_4 }, null, -1))
const _hoisted_22 = [
  _hoisted_21
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_technician_detail_info = _resolveComponent("technician-detail-info")!
  const _component_localized_text = _resolveComponent("localized-text")!
  const _component_copy_button = _resolveComponent("copy-button")!
  const _component_time_filter_container = _resolveComponent("time-filter-container")!
  const _component_ticket_card = _resolveComponent("ticket-card")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("img", {
        src: _imports_0,
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('closeTecnicoDetailSection')))
      })
    ]),
    _createVNode(_component_technician_detail_info, { technicianDetail: _ctx.technicianDetail }, null, 8, ["technicianDetail"]),
    _hoisted_3,
    (_ctx.mapRoute)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createElementVNode("button", {
            class: "button btn-primary w-100 mt-3 mb-4",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.sendPath()))
          }, [
            _createVNode(_component_localized_text, {
              localizedKey: "Invia percorso",
              text: "Invia percorso"
            })
          ]),
          _createElementVNode("div", _hoisted_5, [
            _hoisted_6,
            _createElementVNode("div", _hoisted_7, [
              _createVNode(_component_localized_text, {
                class: "fs_10 fw_500 lightgrey d-block",
                localizedKey: "Posizione tecnico",
                text: "Posizione tecnico"
              }),
              _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.mapRoute.startPointLatitude) + ", " + _toDisplayString(_ctx.mapRoute.startPointLongitude), 1)
            ])
          ]),
          _hoisted_9,
          _createElementVNode("div", _hoisted_10, [
            _hoisted_11,
            _createElementVNode("div", _hoisted_12, [
              _createVNode(_component_localized_text, {
                class: "fs_10 fw_500 lightgrey d-block",
                localizedKey: "Destinazione",
                text: "Destinazione"
              }),
              _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.mapRoute.destinationName), 1),
              _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.mapRoute.destinationAddress), 1)
            ])
          ]),
          (_ctx.googleMapsUrl)
            ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                _createVNode(_component_localized_text, {
                  class: "fs_10 fw_500 lightgrey d-block",
                  localizedKey: "Percorso da inviare",
                  text: "Percorso da inviare"
                }),
                _createElementVNode("div", _hoisted_16, [
                  _createVNode(_component_copy_button, { text: _ctx.googleMapsUrl }, null, 8, ["text"]),
                  _createElementVNode("a", {
                    href: _ctx.googleMapsUrl,
                    target: "_blank",
                    class: "fs_12 fw_500 mapsUrl ms-2"
                  }, _toDisplayString(_ctx.googleMapsUrl), 9, _hoisted_17)
                ]),
                (_ctx.showGoogleMapsRouteSent)
                  ? (_openBlock(), _createBlock(_Transition, {
                      key: 0,
                      name: "opacity",
                      class: "duration04 no_leave_animation",
                      appear: ""
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_18, [
                          _createVNode(_component_localized_text, {
                            localizedKey: "Email inviata correttamente",
                            text: "Email inviata correttamente"
                          })
                        ])
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true)
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_19, [
          _createVNode(_component_time_filter_container, {
            onChanged: _cache[2] || (_cache[2] = ($event: any) => (_ctx.technicianTimeFilter = $event)),
            class: "justify-content-center mb-4"
          }),
          _createElementVNode("div", _hoisted_20, [
            (_ctx.technicianTickets.length == 0 && _ctx.technicianTimeFilter == 'Previous')
              ? (_openBlock(), _createBlock(_component_localized_text, {
                  key: 0,
                  class: "pt-4 text-center d-block",
                  localizedKey: "Nessun ticket passato",
                  text: "Nessun ticket passato"
                }))
              : _createCommentVNode("", true),
            (_ctx.technicianTickets.length == 0 && _ctx.technicianTimeFilter == 'Live')
              ? (_openBlock(), _createBlock(_component_localized_text, {
                  key: 1,
                  class: "pt-4 text-center d-block",
                  localizedKey: "Nessun ticket presente",
                  text: "Nessun ticket presente"
                }))
              : _createCommentVNode("", true),
            (_ctx.technicianTickets.length == 0 && _ctx.technicianTimeFilter == 'Next')
              ? (_openBlock(), _createBlock(_component_localized_text, {
                  key: 2,
                  class: "pt-4 text-center d-block",
                  localizedKey: "Nessun ticket futuro",
                  text: "Nessun ticket futuro"
                }))
              : _createCommentVNode("", true),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.technicianTickets, (ticket, index) => {
              return (_openBlock(), _createBlock(_component_ticket_card, {
                ticket: ticket,
                key: index
              }, null, 8, ["ticket"]))
            }), 128))
          ]),
          (_ctx.showTechnicianScrollTopButton)
            ? (_openBlock(), _createBlock(_Transition, {
                key: 0,
                name: "opacity",
                class: "duration04",
                appear: ""
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", {
                    class: "scrollTopTechnicianButton",
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.scrollToTechnicianTop()))
                  }, _hoisted_22)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]))
  ], 512))
}